import { useParams, Navigate } from 'react-router-dom';

const SectionPage = () => {
  const { slug, sectionSlug } = useParams<{ slug: string; sectionSlug: string }>();

  // Redirect to doc page with hash anchor for backwards compatibility
  if (!slug || !sectionSlug) {
    return <Navigate to="/" replace />;
  }

  return <Navigate to={`/docs/${slug}#${sectionSlug}`} replace />;
};

export default SectionPage;
